
import createIcon from "./createIcon";

export const UploadCloudIcon = createIcon('UploadCloud', (props) => {
  let height = 16;
  let width = height * 62 / 50;
  if (props.height) {
    height = Number(props.height);
    width = Number(props.height) * 62 / 50;
  }
  return (
    <svg {...props} width={width} height={height} viewBox="0 0 62 50">
      <path d="M48.6304,15.2651C47.7981,6.69705,40.555,0,31.7381,0C23.0293,0,15.8618,6.53618,14.8846,14.9517C6.45019,16.3007,0,23.5688,0,32.3529C0,42.0989,7.93123,50,17.7143,50L26.7336,50L26.7334,37.8235C26.7334,36.7189,25.838,35.8235,24.7334,35.8235L19.0567,35.8235C17.3053,35.8235,16.3998,33.7318,17.5984,32.4548L29.5417,19.7302C30.3317,18.8885,31.6683,18.8885,32.4583,19.7302L44.4016,32.4548C45.6002,33.7318,44.6947,35.8235,42.9433,35.8235L37.5908,35.8235C36.4862,35.8235,35.5908,36.7189,35.5908,37.8235L35.5907,50L45.7619,50L45.7619,49.9241C54.8526,49.177,62,41.6025,62,32.3529C62,24.1025,56.3094,17.1983,48.6304,15.2651Z" fill={props.color} fillOpacity="1" />
    </svg >
  )
});
